import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';

interface RemoveMemberData {
  teamId: string;
  userId: string;
}

const useRemoveMember = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ teamId, userId }: RemoveMemberData) => {
      await Api.removeMember(teamId, userId);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['teams', 'single', variables.teamId] });
      queryClient.invalidateQueries({ queryKey: ['teams', 'list'] });
      toast.success('Member removed', {
        description: 'Team member has been removed successfully.',
      });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to remove member',
      });
    },
  });
};

export default useRemoveMember;
